var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.activeFontWeights),function(weight,index){return _c('div',{key:index,staticClass:"fontOptions__item",on:{"click":function($event){return _vm.setTextVariable(weight)}}},[_vm._v(" "+_vm._s(weight.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }